import { render, staticRenderFns } from "./historyOrderItem.vue?vue&type=template&id=358f3a88&"
import script from "./historyOrderItem.vue?vue&type=script&lang=js&"
export * from "./historyOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./historyOrderItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports